import {useEffect, useState} from 'react';

import {getEnrichmentCounts} from "api/enrichment";

export const EMPTY_COUNTS = {pending: {products: 0, targets: {}}, missing: {products: 0, targets: {}}, applied: {products: 0, targets: {}}, totals: {pending: 0, missing: 0, applied: 0}};

export default function useEnrichmentCounts(retailerId, body) {
    const [counts, setCounts] = useState(EMPTY_COUNTS);

    useEffect(() => {
        let current = true;
        getEnrichmentCounts(retailerId, body)
            .then((response) => current && setCounts(response))
            .catch(() => current && setCounts(EMPTY_COUNTS));

        return () => {
            current = false;
        };
    }, [retailerId, body]);

    return {counts, setCounts};
}
